if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      const fileImage = document.querySelector(".js-product-files");
      if (fileImage) {
        const inputDesignEl = document.querySelector("#fileDesign");
        const heightHeader = document.querySelector(".header-wrapper");
        inputDesignEl.querySelector(".summary-title").click();
        if (fileImage.value == "") {
          inputDesignEl.classList.add("error");
          window.scroll({
            top: inputDesignEl.offsetTop - heightHeader.offsetHeight,
            behavior: "smooth"
          });
          this.error = true;
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
          return;
        }
      }

      // ---- Check "La touche finale" ----
      const block = document.querySelector(".js-la-touche-finale");
      if (block) {
        const details = document.querySelector("#details-la-touche-finale");
        const dateInput = block.querySelector(".js-input-date");
        const titleInput = block.querySelector(".js-input-title");
        const nameInput = block.querySelector(".js-input-name");
        const collectorCheckbox = block.querySelector(".js-input-checked");

        const dateLabel = dateInput?.previousElementSibling;
        const titleLabel = titleInput?.previousElementSibling;
        const nameLabel = nameInput?.previousElementSibling;

        if (details && !details.hasAttribute("open")) {
          details.setAttribute("open", "true");
        }

        if (dateInput && titleInput && nameInput) {
          const dateVal = dateInput.value.trim();
          const titleVal = titleInput.value.trim();
          const nameVal = nameInput.value.trim();
          const isCollectorChecked = collectorCheckbox?.checked;

          const isAnyFilled = dateVal || titleVal || nameVal;
          const isAllFilled = dateVal && titleVal && nameVal;

          [dateInput, titleInput, nameInput].forEach(el => el.classList.remove("error"));
          [dateLabel, titleLabel, nameLabel].forEach(el => el?.classList.remove("error"));
          details?.classList.remove("error");

          // Nếu không tích checkbox "pas d'étiquette collector" thì phải fill tất cả 3 fields
          if (!isCollectorChecked && !isAllFilled) {
            details.classList.add("error");

            if (!dateVal) {
              dateInput.classList.add("error");
              dateLabel?.classList.add("error");
            }
            if (!titleVal) {
              titleInput.classList.add("error");
              titleLabel?.classList.add("error");
            }
            if (!nameVal) {
              nameInput.classList.add("error");
              nameLabel?.classList.add("error");
            }

            const heightHeader = document.querySelector(".header-wrapper");
            window.scroll({
              top: details.offsetTop - heightHeader.offsetHeight,
              behavior: "smooth"
            });

            this.error = true;
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");

            return;
          }
          // Nếu tích checkbox "pas d'étiquette collector" thì hoặc điền đầy đủ tất cả hoặc để trống tất cả
          else if (isCollectorChecked && isAnyFilled && !isAllFilled) {
            details.classList.add("error");

            if (!dateVal) {
              dateInput.classList.add("error");
              dateLabel?.classList.add("error");
            }
            if (!titleVal) {
              titleInput.classList.add("error");
              titleLabel?.classList.add("error");
            }
            if (!nameVal) {
              nameInput.classList.add("error");
              nameLabel?.classList.add("error");
            }

            const heightHeader = document.querySelector(".header-wrapper");
            window.scroll({
              top: details.offsetTop - heightHeader.offsetHeight,
              behavior: "smooth"
            });

            this.error = true;
            this.submitButton.classList.remove("loading");
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");

            return;
          }
        }
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          const pickture = document.querySelector("#productPick");
          const fileNameEL = document.querySelector(".js-image-file-input");
          if (fileNameEL) {
            if (pickture) {
              let pickPath = pickture.getAttribute("src");
              let pickTitle = document.querySelector(".js-input-title").value;
              let pickDate = document.querySelector(".js-input-date").value;
              let pickPrenom = document.querySelector(".js-proper-name").value;
              ProductModule.uploadDesign(pickPath, pickTitle, pickDate, pickPrenom);
            }
          }

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
